import { ArrowIcon } from "./ArrowIcon";
import { CREATE_ACCOUNT_HREF } from "./constants";
import { Closing, ClosingAction } from "./styles";

export function ClosingSection() {
  return (
    <Closing>
      <div>
        <h2>Your money. Fewer unanswered questions.</h2>
        <p>
          Start with what you have today. Build a financial picture you can
          return to, understand, and keep up to date.
        </p>
      </div>
      <ClosingAction as="a" href={CREATE_ACCOUNT_HREF}>
        Create your account <ArrowIcon />
      </ClosingAction>
    </Closing>
  );
}
